import styled from 'styled-components'

export const InputToggleWrap = styled.div`
  width: 100%;
`
